"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _isFileManagerUrl = _interopRequireDefault(require("FileManagerLib/utils/isFileManagerUrl"));

var _q = _interopRequireDefault(require("q"));

var _hubl = require("../../utils/hubl");

var _makeCancelable = require("../../utils/makeCancelable");

var _link = require("../../utils/link");

var _iterables = require("../../utils/iterables");

var _link2 = require("../../constants/link");

var _usageTracking = require("../../constants/usageTracking");

var _constants = require("../../api/constants");

var _anchor = require("../../utils/anchor");

var withLinkState = function withLinkState(WrappedComponent) {
  var ManagedLinks =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(ManagedLinks, _Component);

    function ManagedLinks(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ManagedLinks);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ManagedLinks).call(this, props));

      _this.checkForAnchorLink = function (href, callback) {
        var anchorName = (0, _anchor.deserializeAnchorFromLink)(href);

        var anchors = _this.props.fetchAnchors(anchorName);

        if (anchors.length) {
          callback({
            linkType: _link2.LinkTypes.ANCHOR,
            linkDisplayName: anchorName
          });
        } else {
          callback(_this.getExternalUrl(href));
        }
      };

      _this.fetchLinkType = function () {
        var _this$props = _this.props,
            href = _this$props.href,
            cache = _this$props.cache,
            useNoLinkOption = _this$props.useNoLinkOption,
            insertLink = _this$props.insertLink,
            allowMeetingLink = _this$props.allowMeetingLink,
            allowAnchorLinks = _this$props.allowAnchorLinks;
        _this.linkTypePromise = (0, _makeCancelable.makeCancelable)(new _q.default.Promise(function (resolve) {
          if (cache[href]) {
            resolve((0, _iterables.pick)(_link2.CacheableLinkFields, cache[href]));
          } else if (!href) {
            if (useNoLinkOption && !insertLink) {
              resolve({
                linkType: _link2.LinkTypes.NONE,
                linkDisplayName: ''
              });
            } else {
              resolve(_this.getExternalUrl(href));
            }
          } else if (allowAnchorLinks && href.startsWith('#')) {
            _this.checkForAnchorLink(href, resolve);
          } else if (href.startsWith('mailto:')) {
            resolve({
              linkType: _link2.LinkTypes.EMAIL,
              linkDisplayName: href.split('mailto:')[1]
            });
          } else if ((0, _hubl.getHublVariable)(href)) {
            if ((0, _hubl.getEmailSystemHublVar)(href)) {
              resolve({
                linkType: _link2.LinkTypes.EMAIL_SUBSCRIPTION,
                linkDisplayName: (0, _hubl.getHublVariableLabel)((0, _hubl.getEmailSystemHublVar)(href))
              });
            } else {
              resolve(_this.getExternalUrl(href));
            }
          } else if ((0, _hubl.hasHublVariable)(href) || (0, _link.hasAnchorLink)(href)) {
            resolve(_this.getExternalUrl(href));
          } else if ((0, _isFileManagerUrl.default)(href)) {
            _this.checkForFileLink(href).then(resolve).catch(function () {
              _this.checkForPageUrl(href).then(resolve).catch(function () {
                resolve(_this.getExternalUrl(href));
              });
            });
          } else if (allowMeetingLink && (0, _link.isMeetingLink)(href)) {
            _this.checkForMeetingLink(href).then(resolve).catch(function () {
              resolve(_this.getExternalUrl(href));
            });
          } else {
            _this.checkForPageUrl(href).then(resolve).catch(function () {
              resolve(_this.getExternalUrl(href));
            });
          }
        }));

        _this.linkTypePromise.promise.then(function (linkType) {
          _this.handleUpdate(linkType, false);
        }).catch(function (reason) {
          console.warn('linkType fetch rejected', reason);
        });
      };

      _this.handleClose = function () {
        var onClose = _this.props.onClose;

        if (_this.state.href === '') {
          // Restore the link state since it was only partially updated
          _this.setState((0, _extends2.default)({}, _this.lastCompleteLinkState));

          if (onClose) onClose();
        }
      };

      var _href = props.href,
          noFollow = props.noFollow,
          externalLink = props.externalLink;
      _this.checkForFileLink = _this.checkForFileLink.bind((0, _assertThisInitialized2.default)(_this));
      _this.checkForPageUrl = _this.checkForPageUrl.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleUpdate = _this.handleUpdate.bind((0, _assertThisInitialized2.default)(_this));
      _this.trackLinkUsage = _this.trackLinkUsage.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleLinkTypeChange = _this.handleLinkTypeChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        href: _href,
        noFollow: noFollow,
        externalLink: externalLink,
        linkType: _link2.LinkTypes.URL,
        linkDisplayName: _href
      };
      return _this;
    }

    (0, _createClass2.default)(ManagedLinks, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fetchLinkType();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.linkTypePromise.cancel(); // Race condition with page fetching and state updating etc

        if (this.props.trackLinkUsage && this.initialLinkInfo) {
          this.trackLinkUsage();
        }
      }
    }, {
      key: "trackLinkUsage",
      value: function trackLinkUsage() {
        // We want to track changes to href but not the href value itself
        var pickTrackingChangeValues = (0, _iterables.pick)([].concat((0, _toConsumableArray2.default)(_link2.TrackableLinkFields), ['href']));
        var initialTrackingValues = pickTrackingChangeValues(this.initialLinkInfo);
        var trackingValues = pickTrackingChangeValues(this.state);

        if (trackingValues !== initialTrackingValues) {
          var trackingAction = initialTrackingValues.linkType === _link2.LinkTypes.NONE ? _usageTracking.INSERT_LINK : _usageTracking.UPDATE_LINK;
          this.props.trackLinkUsage(trackingAction, (0, _iterables.omit)(['href'], trackingValues));
        }
      }
    }, {
      key: "checkForFileLink",
      value: function checkForFileLink(href) {
        var fetchFileFromUrl = this.props.fetchFileFromUrl;
        return fetchFileFromUrl(href).then(function (fileData) {
          return {
            linkType: _link2.LinkTypes.FILE,
            linkDisplayName: fileData.title + "." + fileData.extension,
            fileMeta: {
              fileName: fileData.title + "." + fileData.extension,
              size: fileData.size,
              type: fileData.type
            }
          };
        });
      }
    }, {
      key: "checkForPageUrl",
      value: function checkForPageUrl(href) {
        var _this2 = this;

        return new _q.default.Promise(function (resolve, reject) {
          var _this2$props = _this2.props,
              scopes = _this2$props.scopes,
              fetchPageBySlug = _this2$props.fetchPageBySlug;

          if (scopes.includes(_constants.CONTENT_ACCESS_SCOPE) || scopes.includes(_constants.KNOWLEDGE_ACCESS_SCOPE)) {
            var _getUrlParts = (0, _link.getUrlParts)(href),
                domain = _getUrlParts.domain,
                slug = _getUrlParts.slug; // required to fix issues with getting a 403 from the content-search api


            fetchPageBySlug(slug).then(function (pageData) {
              var pageObject = pageData.objects.find(function (object) {
                return object.resolvedDomain === domain;
              });

              if (pageObject) {
                var payload = {
                  linkType: _link2.LinkTypes.PAGE,
                  linkDisplayName: pageObject.title
                };
                resolve(payload);
              } else {
                reject('no matching page object');
              }
            });
          } else {
            reject('content access not in scope');
          }
        });
      }
    }, {
      key: "checkForMeetingLink",
      value: function checkForMeetingLink(href) {
        var fetchMeetingBySlug = this.props.fetchMeetingBySlug;
        var slug = (0, _link.getMeetingLinkSlug)(href);
        return fetchMeetingBySlug(slug).then(function (meeting) {
          return {
            linkType: _link2.LinkTypes.MEETING,
            linkDisplayName: meeting.name || meeting.link
          };
        });
      }
    }, {
      key: "getExternalUrl",
      value: function getExternalUrl(href) {
        return {
          linkType: _link2.LinkTypes.URL,
          linkDisplayName: href
        };
      }
    }, {
      key: "handleUpdate",
      value: function handleUpdate(update) {
        var _this3 = this;

        var updateSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // Update Popover State
        this.setState((0, _extends2.default)({}, update), function () {
          if (!_this3.initialLinkInfo) {
            _this3.initialLinkInfo = _this3.state;
          } // Store this fully updated link state


          _this3.lastCompleteLinkState = _this3.state;

          if (_link2.CacheableLinkTypes.includes(_this3.state.linkType) && _this3.state.href) {
            _this3.props.updateCache(_this3.state.href, (0, _iterables.pick)(_link2.CacheableLinkFields, _this3.state));
          }

          if (updateSource) {
            // Update source state with new state
            _this3.props.onUpdate(_this3.state);
          }
        });
      }
    }, {
      key: "handleLinkTypeChange",
      value: function handleLinkTypeChange(linkType) {
        var _this4 = this;

        this.setState({
          linkType: linkType,
          href: ''
        }, function () {
          if (_this4.props.onLinkTypeChange) {
            _this4.props.onLinkTypeChange(linkType);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            fileMeta = _this$state.fileMeta,
            linkData = (0, _objectWithoutProperties2.default)(_this$state, ["fileMeta"]);
        return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          onLinkTypeChange: this.handleLinkTypeChange,
          onUpdate: this.handleUpdate,
          dropdownClassName: this.props.dropdownClassName,
          showRefAndTargetControls: this.props.showRefAndTargetControls,
          fetchPages: this.props.fetchPages,
          onSelectFile: this.props.onSelectFile,
          onClose: this.handleClose,
          currentFileMeta: fileMeta
        }, linkData));
      }
    }]);
    return ManagedLinks;
  }(_react.Component);

  ManagedLinks.propTypes = {
    fetchPageBySlug: _react.PropTypes.func.isRequired,
    fetchMeetingBySlug: _react.PropTypes.func.isRequired,
    updateCache: _react.PropTypes.func.isRequired,
    trackLinkUsage: _react.PropTypes.func,
    cache: _react.PropTypes.object.isRequired,
    onUpdate: _react.PropTypes.func,
    onLinkTypeChange: _react.PropTypes.func,
    onClose: _react.PropTypes.func,
    href: _react.PropTypes.string,
    noFollow: _react.PropTypes.bool,
    externalLink: _react.PropTypes.bool,
    showRefAndTargetControls: _react.PropTypes.bool,
    fetchFileFromUrl: _react.PropTypes.func,
    fetchPages: _react.PropTypes.func,
    fetchAnchors: _react.PropTypes.func,
    onSelectFile: _react.PropTypes.func,
    dropdownClassName: _react.PropTypes.string,
    useNoLinkOption: _react.PropTypes.bool,
    scopes: _react.PropTypes.array,
    insertLink: _react.PropTypes.bool,
    allowMeetingLink: _react.PropTypes.bool,
    allowAnchorLinks: _react.PropTypes.bool
  };
  ManagedLinks.defaultProps = {
    cache: {},
    scopes: []
  };
  ManagedLinks.displayName = "withLinkState(" + (0, _getComponentName.default)(WrappedComponent) + ")";
  return ManagedLinks;
};

var _default = withLinkState;
exports.default = _default;
module.exports = exports.default;